export const config = {
  is_enabled: true,
  supported_extensions: ['png', 'jpg', 'jpeg', 'webp'],
  matching_paths: ['cdn-cgi/image'],
  host_transformation_url_map: {
    'indcdn.indmoney.com': 'https://indcdn.indmoney.com/cdn-cgi/image',
    'cdn.indiawealth.in': 'https://cdn.indiawealth.in/cdn-cgi/image',
  },
  quality: 90,
  format: 'auto',
  imgOptimizingPercent: 50,
}
